import React, { useState, useEffect, useRef } from 'react';

const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 600;

function formatCreatedAt(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${y}-${m}-${day} ${hh}:${mm}`;
  } catch {
    return iso;
  }
}

export default function BookingDetailPopover({ booking }) {
  const [open, setOpen] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    setMobileView(isMobile());
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const memberLabel = booking.customerSub
    ? `회원${booking.authProvider ? ` (${booking.authProvider})` : ''}`
    : '비회원';

  const panelStyle = mobileView
    ? {
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)', zIndex: 100,
        width: 'min(90vw, 320px)',
      }
    : {
        position: 'absolute', top: 'calc(100% + 4px)', right: 0,
        zIndex: 50, width: 280,
      };

  return (
    <div ref={wrapRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        aria-label="상세 정보"
        style={{
          background: 'transparent', border: 'none', cursor: 'pointer',
          fontSize: '1.1rem', color: 'var(--text-muted)', padding: '4px 8px',
        }}
      >⋯</button>

      {open && (
        <>
          {mobileView && (
            <div
              onClick={() => setOpen(false)}
              style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
                zIndex: 99,
              }}
            />
          )}
          <div
            style={{
              ...panelStyle,
              background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 'var(--radius)', boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
              padding: 16, fontSize: '0.85rem',
            }}
          >
            <div style={{ marginBottom: 12 }}>
              <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginBottom: 2 }}>메모</div>
              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {booking.note
                  ? booking.note
                  : <span style={{ color: 'var(--text-muted)' }}>메모 없음</span>}
              </div>
            </div>
            <div style={{ marginBottom: 8 }}>
              <span style={{ color: 'var(--text-muted)' }}>등록일: </span>
              {formatCreatedAt(booking.createdAt)}
            </div>
            <div style={{ marginBottom: 8 }}>
              <span style={{ color: 'var(--text-muted)' }}>예약 ID: </span>
              <code style={{ fontSize: '0.75rem' }}>{booking.bookingId}</code>
            </div>
            <div>
              <span style={{ color: 'var(--text-muted)' }}>구분: </span>
              {memberLabel}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
